export type ClientLogPayload = Record<string, unknown>;

export function sendClientLog(payload: ClientLogPayload): void {
  try {
    const body = JSON.stringify({ ...payload, ts: Date.now() });
    if (typeof navigator !== 'undefined' && 'sendBeacon' in navigator) {
      (navigator as any).sendBeacon('/__client-log', new Blob([body], { type: 'application/json' }));
      return;
    }
    fetch('/__client-log', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body,
      keepalive: true,
    }).catch((e: any) => {console.error(e);});
  } catch(e: any) {console.error(e);}
}


